export const validateEmail = (email) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|net|org|id|co|gov|edu|io|biz|info|xyz|dev)$/i.test(
    email
  );
};
